import React from "react";
import { NavLink } from "react-router-dom";
import "../../../components/jds/jds.css";
import "../calculatorApi.css";

// As rotas que pertencem à aba Listagem. Ela cobre duas (Cálculos e Consultas),
// então o destaque não pode vir do casamento de prefixo do NavLink: sem `exact`,
// `/calculator-api` casaria também com `/calculator-api/vinculacao`; com `exact`,
// deixaria de casar com `/calculator-api/queries`. Daí a lista explícita.
export const LISTAGEM_PATHS = ["/calculator-api", "/calculator-api/queries"];

const VINCULACAO_PATH = "/calculator-api/vinculacao";

// Abas de 1º nível, por rota — cada uma é linkável e sobrevive a refresh.
//
// Leva a própria .jds-scope para resolver os tokens também em quem a usa fora
// de um escopo (a aninhada é inofensiva: redefine os mesmos tokens).
export default function CalculatorApiTabs() {
  return (
    <div className="jds-scope ca-header">
      <h1 className="jds-title-lg">Consumo API B2B</h1>

      <ul className="ca-tabs">
        <li>
          <NavLink
            className="ca-tab"
            to={LISTAGEM_PATHS[0]}
            isActive={(match, location) =>
              LISTAGEM_PATHS.includes(location.pathname)
            }
          >
            Listagem
          </NavLink>
        </li>
        <li>
          <NavLink className="ca-tab" to={VINCULACAO_PATH}>
            Vinculação
          </NavLink>
        </li>
      </ul>
    </div>
  );
}
